// ----------------------------------------------------------------------------
// Accessibility JavaScript
// ----------------------------------------------------------------------------
//
// Scripts to support Accessibility
//
// ----------------------------------------------------------------------------

// Load Shopify Accessibility (a11y) Scripts
import {focusHash, bindInPageLinks} from '@shopify/theme-a11y';

// Apply common accessibility fixes
focusHash();
bindInPageLinks();
